import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useRef, useState, } from 'react';
import { ConfirmModal, PromptModal } from './components/Modal.js';
import { ToastStack } from './components/Toast.js';
const Ctx = createContext(null);
export function DialogProvider({ children }) {
    const [confirmReq, setConfirmReq] = useState(null);
    const [promptReq, setPromptReq] = useState(null);
    const [toasts, setToasts] = useState([]);
    const toastSeq = useRef(0);
    const dismissToast = useCallback((id) => {
        setToasts((arr) => arr.filter((t) => t.id !== id));
    }, []);
    const value = useMemo(() => ({
        confirm: (req) => new Promise((resolve) => {
            setConfirmReq((prev) => {
                prev?.resolve(false);
                return { ...req, resolve };
            });
        }),
        prompt: (req) => new Promise((resolve) => {
            setPromptReq((prev) => {
                prev?.resolve(null);
                return { ...req, resolve };
            });
        }),
        toast: (req) => {
            toastSeq.current += 1;
            const id = `t${toastSeq.current}`;
            setToasts((arr) => [...arr, { id, ...req }]);
        },
    }), []);
    return (_jsxs(Ctx.Provider, { value: value, children: [children, _jsx(ConfirmModal, { open: confirmReq !== null, title: confirmReq?.title ?? '', body: confirmReq?.body, confirmLabel: confirmReq?.confirmLabel, cancelLabel: confirmReq?.cancelLabel, destructive: confirmReq?.destructive, onConfirm: () => {
                    confirmReq?.resolve(true);
                    setConfirmReq(null);
                }, onCancel: () => {
                    confirmReq?.resolve(false);
                    setConfirmReq(null);
                } }), _jsx(PromptModal, { open: promptReq !== null, title: promptReq?.title ?? '', body: promptReq?.body, initialValue: promptReq?.initialValue, placeholder: promptReq?.placeholder, confirmLabel: promptReq?.confirmLabel, cancelLabel: promptReq?.cancelLabel, destructive: promptReq?.destructive, onConfirm: (v) => {
                    promptReq?.resolve(v);
                    setPromptReq(null);
                }, onCancel: () => {
                    promptReq?.resolve(null);
                    setPromptReq(null);
                } }), _jsx(ToastStack, { toasts: toasts, onDismiss: dismissToast })] }));
}
function useCtx() {
    const v = useContext(Ctx);
    if (!v)
        throw new Error('useConfirm/usePrompt/useToast must be used inside <DialogProvider>');
    return v;
}
export function useConfirm() {
    return useCtx().confirm;
}
export function usePrompt() {
    return useCtx().prompt;
}
export function useToast() {
    return useCtx().toast;
}
//# sourceMappingURL=providers.js.map